import 'bootstrap'
import 'perfect-scrollbar/css/perfect-scrollbar.css'
import './estilos/aplicacion.scss'
import {
  actualizarPerfil,
  cambiarContrasena,
  cerrarSesion,
  consultarPerfil,
  ErrorApi,
  iniciarSesion,
  renovarSesion,
  restablecerContrasena,
  solicitarRecuperacion,
  normalizarContrasenaPegada,
  type Perfil,
} from './modulos/identidad/cliente-identidad.js'
import { tieneSesionCsrf } from './modulos/identidad/cliente-identidad.js'
import {
  cargarCatalogos,
  prepararInterfazCatalogos,
} from './modulos/catalogos/interfaz-catalogos.js'
import {
  cargar as cargarActores,
  configurarInterfazActores,
} from './modulos/actores/interfaz-actores.js'
import {
  cargarExpedientes,
  configurarInterfazExpedientes,
  prepararInterfazExpedientes,
  mostrarListaExpedientes,
  abrirNotificacionEnExpediente,
  solicitarDecisionLegal,
} from './modulos/expedientes/interfaz-expedientes.js'
import { mostrarReportes } from './modulos/reportes/interfaz-reportes.js'
import { mostrarObservacionesInstitucionales } from './modulos/observaciones-institucionales/interfaz-observaciones-institucionales.js'
import { mostrarSesionExpirada, notificar } from './modulos/fundacion/alertas.js'
import { cargarTablero } from './modulos/tablero/interfaz-tablero.js'
import {
  listarNotificaciones,
  marcarNotificacionLeida,
  type Notificacion,
} from './modulos/seguimiento/cliente-seguimiento.js'

function elemento<T extends Element>(selector: string): T {
  const encontrado = document.querySelector<T>(selector)
  if (!encontrado) throw new Error(`No existe el elemento requerido: ${selector}`)
  return encontrado
}

const sidebar = elemento<HTMLElement>('#sidebar')
const main = elemento<HTMLElement>('#main')
function cerrarMenuMovil(): void {
  if (window.innerWidth < 1200) {
    sidebar.classList.add('inactive')
    sidebar.classList.remove('active')
    elemento<HTMLButtonElement>('#abrir-menu').setAttribute('aria-expanded', 'false')
  }
}
window.addEventListener('resize', () => {
  if (window.innerWidth >= 1200 && !document.body.classList.contains('modo-acceso')) {
    sidebar.classList.remove('inactive')
    sidebar.classList.add('active')
    elemento<HTMLButtonElement>('#abrir-menu').setAttribute('aria-expanded', 'true')
  }
})
elemento<HTMLButtonElement>('#abrir-menu').addEventListener('click', () => {
  const oculto = sidebar.classList.toggle('inactive')
  sidebar.classList.toggle('active', !oculto)
  elemento<HTMLButtonElement>('#abrir-menu').setAttribute('aria-expanded', String(!oculto))
})
elemento<HTMLButtonElement>('#cerrar-menu').addEventListener('click', () => {
  sidebar.classList.add('inactive')
  sidebar.classList.remove('active')
  elemento<HTMLButtonElement>('#abrir-menu').setAttribute('aria-expanded', 'false')
})
let formularioSucio = false
function limpiarFormularios(): void {
  document.querySelectorAll<HTMLFormElement>('form').forEach((formulario) => {
    formulario.reset()
    formulario.classList.remove('was-validated')
    formulario
      .querySelectorAll('.is-valid,.is-invalid')
      .forEach((campo) => campo.classList.remove('is-valid', 'is-invalid'))
  })
  formularioSucio = false
}
document.addEventListener(
  'input',
  (evento) => {
    if (
      evento.target instanceof HTMLInputElement ||
      evento.target instanceof HTMLSelectElement ||
      evento.target instanceof HTMLTextAreaElement
    )
      formularioSucio = true
  },
  true,
)
document.addEventListener(
  'blur',
  (evento) => {
    if (evento.target instanceof HTMLInputElement && evento.target.type === 'password') {
      evento.target.value = normalizarContrasenaPegada(evento.target.value)
    }
  },
  true,
)
document.addEventListener(
  'submit',
  () => {
    formularioSucio = false
  },
  true,
)
window.addEventListener('beforeunload', (evento) => {
  if (formularioSucio) {
    evento.preventDefault()
    evento.returnValue = ''
  }
})
function confirmarCambioVista(): boolean {
  if (!formularioSucio) return true
  const continuar = window.confirm('Hay cambios sin guardar. ¿Desea descartarlos?')
  if (continuar) formularioSucio = false
  if (continuar) limpiarFormularios()
  return continuar
}
function ocultarObservacionesInstitucionales(): void {
  vistaObservacionesInstitucionales.classList.add('d-none')
  elemento('#item-menu-observaciones-institucionales').classList.remove('active')
}
document.addEventListener(
  'click',
  (evento) => {
    const objetivo = evento.target instanceof Element ? evento.target.closest('button, a') : null
    if (
      !objetivo ||
      objetivo.id === 'abrir-menu' ||
      objetivo.id === 'cargar-foto-identificacion' ||
      objetivo.matches('[data-password-target]') ||
      objetivo.closest('#modal-legal') ||
      objetivo.closest('.swal2-container') ||
      (objetivo instanceof HTMLButtonElement && objetivo.type === 'submit')
    )
      return
    if (formularioSucio && !confirmarCambioVista()) {
      evento.preventDefault()
      evento.stopImmediatePropagation()
    }
  },
  true,
)

const vistaAcceso = elemento<HTMLElement>('#vista-acceso')
const vistaPerfil = elemento<HTMLElement>('#vista-perfil')
const vistaTablero = elemento<HTMLElement>('#vista-tablero')
const vistaRestablecimiento = elemento<HTMLElement>('#vista-restablecimiento')
const vistaCatalogos = elemento<HTMLElement>('#vista-catalogos')
const vistaActores = elemento<HTMLElement>('#vista-actores')
const vistaExpedientes = elemento<HTMLElement>('#vista-expedientes')
const vistaObservacionesInstitucionales = elemento<HTMLElement>(
  '#vista-observaciones-institucionales',
)
const vistaReportes = elemento<HTMLElement>('#vista-reportes')
const alertaAcceso = elemento<HTMLElement>('#alerta-acceso')
const alertaPerfil = elemento<HTMLElement>('#alerta-perfil')
let perfilActual: Perfil | null = null
let sesionExpiradaMostrada = false
let temporizadorExpiracion: number | undefined

function mensajeError(error: unknown): string {
  return error instanceof ErrorApi ? error.message : 'No fue posible comunicarse con el sistema.'
}

function mostrarAlerta(elementoAlerta: HTMLElement, mensaje: string, tipo = 'danger'): void {
  elementoAlerta.className = 'alert d-none'
  notificar(mensaje, tipo === 'danger' ? 'error' : (tipo as 'success' | 'warning' | 'info'))
}

function programarExpiracion(perfil: Perfil): void {
  if (temporizadorExpiracion !== undefined) window.clearTimeout(temporizadorExpiracion)
  // El access token dura quince minutos; avisar un minuto antes para todos los roles.
  temporizadorExpiracion = window.setTimeout(
    () => {
      if (sesionExpiradaMostrada || document.body.classList.contains('modo-acceso')) return
      sesionExpiradaMostrada = true
      mostrarSesionExpirada(async () => {
        try {
          await renovarSesion()
          sesionExpiradaMostrada = false
          programarExpiracion(perfil)
          notificar('Sesión extendida correctamente.', 'success')
        } catch (error) {
          sesionExpiradaMostrada = false
          throw error
        }
      }, ejecutarCierreSesion)
    },
    14 * 60 * 1000,
  )
}

document.querySelectorAll<HTMLButtonElement>('[data-password-target]').forEach((boton) => {
  boton.addEventListener('click', () => {
    const selector = boton.dataset.passwordTarget
    if (!selector) return
    const campo = document.querySelector<HTMLInputElement>(selector)
    if (!campo) return
    const visible = campo.type === 'text'
    campo.type = visible ? 'password' : 'text'
    boton.setAttribute('aria-pressed', String(!visible))
    boton.setAttribute('aria-label', visible ? 'Mostrar contraseña' : 'Ocultar contraseña')
    const icono = boton.querySelector('i')
    icono?.classList.toggle('bi-eye', visible)
    icono?.classList.toggle('bi-eye-slash', !visible)
    campo.focus()
  })
})

function rellenarCamposPerfil(perfil: Perfil): void {
  // Los datos del perfil vienen de la API; no dependemos de los valores que
  // hayan quedado en el formulario después de cambiar de vista.
  elemento<HTMLInputElement>('#nombres-perfil').value = perfil.nombres
  elemento<HTMLInputElement>('#apellidos-perfil').value = perfil.apellidos
  elemento<HTMLInputElement>('#correo-perfil').value = perfil.correo
  elemento<HTMLInputElement>('#celular-perfil').value = perfil.celular ?? ''
  elemento<HTMLInputElement>('#version-perfil').value = String(perfil.version)
}

function cargarPerfil(perfil: Perfil, abrirTablero = true): void {
  // Cada autenticación inicia una sesión de interfaz limpia; no conserva
  // borradores ni estados de validación del usuario o vista anterior.
  limpiarFormularios()
  perfilActual = perfil
  const esEstudiante = perfil.roles.includes('ESTUDIANTE')
  elemento('#etiqueta-menu-expedientes').textContent = esEstudiante
    ? 'Carpeta del Estudiante'
    : 'Carpetas del Estudiante'
  elemento('#titulo-expedientes').textContent = esEstudiante
    ? 'Carpeta del Estudiante'
    : 'Carpetas del Estudiante'
  elemento('#tarjeta-datos-personales').classList.toggle('d-none', esEstudiante)
  document.body.classList.remove('modo-acceso')
  rellenarCamposPerfil(perfil)
  elemento<HTMLInputElement>('#correo-perfil').readOnly = !esEstudiante
  elemento<HTMLElement>('#navbar-usuario').textContent = `${perfil.nombres} ${perfil.apellidos}`
  elemento<HTMLElement>('#navbar-rol').textContent = perfil.roles[0] ?? 'Usuario'
  vistaAcceso.classList.add('d-none')
  vistaTablero.classList.toggle('d-none', !abrirTablero)
  vistaPerfil.classList.toggle('d-none', abrirTablero)
  vistaCatalogos.classList.add('d-none')
  vistaActores.classList.add('d-none')
  vistaExpedientes.classList.add('d-none')
  vistaObservacionesInstitucionales.classList.add('d-none')
  vistaReportes.classList.add('d-none')
  vistaObservacionesInstitucionales.classList.add('d-none')
  elemento('#item-menu-tablero').classList.toggle('active', abrirTablero)
  elemento('#item-menu-perfil').classList.toggle('active', !abrirTablero)
  elemento('#item-menu-catalogos').classList.remove('active')
  elemento('#item-menu-actores').classList.remove('active')
  elemento('#item-menu-expedientes').classList.remove('active')
  elemento('#item-menu-observaciones-institucionales').classList.remove('active')
  elemento('#item-menu-reportes').classList.remove('active')
  const administraCatalogos = perfil.roles.includes('COORDINADOR_GENERAL')
  elemento<HTMLElement>('#item-menu-catalogos').classList.toggle('d-none', !administraCatalogos)
  const administraActores = perfil.roles.some((rol) =>
    ['COORDINADOR_GENERAL', 'COORDINADOR_ASESORES'].includes(rol),
  )
  elemento<HTMLElement>('#item-menu-actores').classList.toggle('d-none', !administraActores)
  if (administraActores) configurarInterfazActores(perfil.roles)
  elemento<HTMLElement>('#item-menu-expedientes').classList.remove('d-none')
  elemento<HTMLElement>('#item-menu-observaciones-institucionales').classList.toggle(
    'd-none',
    !perfil.roles.some((rol) =>
      ['ASESOR', 'COORDINADOR_GENERAL', 'COORDINADOR_ASESORES', 'TITULAR', 'ESTUDIANTE'].includes(
        rol,
      ),
    ),
  )
  elemento<HTMLElement>('#item-menu-reportes').classList.toggle(
    'd-none',
    !perfil.roles.some((rol) =>
      ['COORDINADOR_GENERAL', 'COORDINADOR_ASESORES', 'ASESOR'].includes(rol),
    ),
  )
  configurarInterfazExpedientes(perfil.roles)
  mostrarReportes(perfil.roles)
  void cargarTablero(perfil.roles)
  void cargarNotificacionesHeader().catch(() => undefined)
  sidebar.classList.remove('inactive')
  sidebar.classList.add('active')
  elemento<HTMLButtonElement>('#abrir-menu').setAttribute('aria-expanded', 'true')
  main.classList.add('layout-navbar')
  programarExpiracion(perfil)
}

function mostrarAcceso(): void {
  limpiarFormularios()
  if (temporizadorExpiracion !== undefined) window.clearTimeout(temporizadorExpiracion)
  temporizadorExpiracion = undefined
  sesionExpiradaMostrada = false
  document.body.classList.add('modo-acceso')
  vistaPerfil.classList.add('d-none')
  vistaTablero.classList.add('d-none')
  vistaRestablecimiento.classList.add('d-none')
  vistaAcceso.classList.remove('d-none')
  vistaCatalogos.classList.add('d-none')
  vistaActores.classList.add('d-none')
  vistaExpedientes.classList.add('d-none')
  vistaObservacionesInstitucionales.classList.add('d-none')
  vistaReportes.classList.add('d-none')
  vistaObservacionesInstitucionales.classList.add('d-none')
  cerrarMenuMovil()
  sidebar.classList.add('inactive')
  elemento<HTMLInputElement>('#correo-acceso').focus()
}

async function cargarNotificacionesHeader(): Promise<void> {
  const respuesta = await listarNotificaciones()
  const lista = elemento<HTMLElement>('#lista-notificaciones-header')
  const pendientes = respuesta.datos.filter((dato) => !dato.leidaEn).length
  elemento('#insignia-notificaciones').textContent = String(pendientes)
  lista.replaceChildren(
    ...(respuesta.datos.length
      ? respuesta.datos.slice(0, 5).map((dato: Notificacion) => {
          const item = document.createElement('button')
          item.type = 'button'
          item.className = `dropdown-item text-wrap ${dato.leidaEn ? '' : 'fw-bold'}`
          item.textContent = `${dato.titulo}: ${dato.mensaje}`
          item.addEventListener('click', () => {
            void marcarNotificacionLeida(dato.id)
              .then(() => {
                // La notificación puede abrirse desde cualquier vista. Primero
                // se muestra el contenedor de expedientes y luego se ubica el
                // estudiante y el módulo relacionado.
                elemento<HTMLButtonElement>('#ir-expedientes').click()
                return abrirNotificacionEnExpediente(dato.recursoTipo, dato.recursoId)
              })
              .then(cargarNotificacionesHeader)
          })
          return item
        })
      : [
          Object.assign(document.createElement('span'), {
            className: 'dropdown-item-text text-muted',
            textContent: 'No hay notificaciones nuevas',
          }),
        ]),
  )
}

elemento<HTMLAnchorElement>('#enlace-notificaciones').addEventListener('click', () => {
  void cargarNotificacionesHeader().catch(() => undefined)
})
window.addEventListener('sesion-expirada', () => {
  if (sesionExpiradaMostrada || document.body.classList.contains('modo-acceso')) return
  if (!perfilActual) return
  sesionExpiradaMostrada = true
  mostrarSesionExpirada(async () => {
    try {
      await renovarSesion()
      sesionExpiradaMostrada = false
      programarExpiracion(perfilActual!)
      notificar('Sesión extendida correctamente.', 'success')
    } catch (error) {
      sesionExpiradaMostrada = false
      throw error
    }
  }, ejecutarCierreSesion)
})
window.addEventListener('sesion-renovada', () => {
  if (perfilActual) {
    sesionExpiradaMostrada = false
    programarExpiracion(perfilActual)
  }
})

prepararInterfazCatalogos()
prepararInterfazExpedientes()
elemento<HTMLButtonElement>('#ir-tablero').addEventListener('click', () => {
  limpiarFormularios()
  ocultarObservacionesInstitucionales()
  vistaPerfil.classList.add('d-none')
  vistaTablero.classList.remove('d-none')
  vistaCatalogos.classList.add('d-none')
  vistaActores.classList.add('d-none')
  vistaExpedientes.classList.add('d-none')
  vistaObservacionesInstitucionales.classList.add('d-none')
  vistaReportes.classList.add('d-none')
  for (const id of [
    'item-menu-perfil',
    'item-menu-catalogos',
    'item-menu-actores',
    'item-menu-expedientes',
    'item-menu-reportes',
  ])
    elemento(`#${id}`).classList.remove('active')
  elemento('#item-menu-tablero').classList.add('active')
  cerrarMenuMovil()
  void cargarTablero(perfilActual?.roles ?? [])
})
elemento<HTMLButtonElement>('#ir-perfil').addEventListener('click', () => {
  limpiarFormularios()
  if (perfilActual) rellenarCamposPerfil(perfilActual)
  ocultarObservacionesInstitucionales()
  vistaCatalogos.classList.add('d-none')
  vistaActores.classList.add('d-none')
  vistaExpedientes.classList.add('d-none')
  vistaObservacionesInstitucionales.classList.add('d-none')
  vistaReportes.classList.add('d-none')
  vistaTablero.classList.add('d-none')
  vistaPerfil.classList.remove('d-none')
  elemento('#item-menu-tablero').classList.remove('active')
  elemento('#item-menu-perfil').classList.add('active')
  elemento('#item-menu-catalogos').classList.remove('active')
  elemento('#item-menu-actores').classList.remove('active')
  elemento('#item-menu-expedientes').classList.remove('active')
  elemento('#item-menu-reportes').classList.remove('active')
  // Se vuelve a consultar el perfil para reflejar cambios hechos en otra
  // sesión o desde otro dispositivo, sin alterar la vista actual.
  void consultarPerfil()
    .then((perfil) => {
      perfilActual = perfil
      rellenarCamposPerfil(perfil)
      elemento<HTMLInputElement>('#correo-perfil').readOnly = !perfil.roles.includes('ESTUDIANTE')
      elemento<HTMLElement>('#navbar-usuario').textContent = `${perfil.nombres} ${perfil.apellidos}`
      elemento<HTMLElement>('#navbar-rol').textContent = perfil.roles[0] ?? 'Usuario'
    })
    .catch(() => undefined)
})
elemento<HTMLButtonElement>('#ir-perfil-navbar').addEventListener('click', () => {
  elemento<HTMLButtonElement>('#ir-perfil').click()
})
elemento<HTMLButtonElement>('#ir-catalogos').addEventListener('click', () => {
  limpiarFormularios()
  ocultarObservacionesInstitucionales()
  vistaPerfil.classList.add('d-none')
  vistaTablero.classList.add('d-none')
  vistaCatalogos.classList.remove('d-none')
  vistaActores.classList.add('d-none')
  vistaExpedientes.classList.add('d-none')
  vistaObservacionesInstitucionales.classList.add('d-none')
  vistaReportes.classList.add('d-none')
  elemento('#item-menu-perfil').classList.remove('active')
  elemento('#item-menu-tablero').classList.remove('active')
  elemento('#item-menu-catalogos').classList.add('active')
  elemento('#item-menu-actores').classList.remove('active')
  elemento('#item-menu-expedientes').classList.remove('active')
  elemento('#item-menu-reportes').classList.remove('active')
  cerrarMenuMovil()
  void cargarCatalogos().catch((error: unknown) =>
    mostrarAlerta(elemento('#alerta-catalogos'), mensajeError(error)),
  )
})
elemento<HTMLButtonElement>('#ir-actores').addEventListener('click', () => {
  limpiarFormularios()
  ocultarObservacionesInstitucionales()
  vistaPerfil.classList.add('d-none')
  vistaCatalogos.classList.add('d-none')
  vistaTablero.classList.add('d-none')
  vistaActores.classList.remove('d-none')
  vistaExpedientes.classList.add('d-none')
  vistaReportes.classList.add('d-none')
  elemento('#item-menu-perfil').classList.remove('active')
  elemento('#item-menu-tablero').classList.remove('active')
  elemento('#item-menu-catalogos').classList.remove('active')
  elemento('#item-menu-actores').classList.add('active')
  elemento('#item-menu-expedientes').classList.remove('active')
  elemento('#item-menu-reportes').classList.remove('active')
  cerrarMenuMovil()
  void cargarActores().catch((error: unknown) =>
    mostrarAlerta(elemento('#alerta-actores'), mensajeError(error)),
  )
})
elemento<HTMLButtonElement>('#ir-expedientes').addEventListener('click', () => {
  limpiarFormularios()
  ocultarObservacionesInstitucionales()
  vistaPerfil.classList.add('d-none')
  vistaCatalogos.classList.add('d-none')
  vistaActores.classList.add('d-none')
  vistaTablero.classList.add('d-none')
  vistaExpedientes.classList.remove('d-none')
  vistaReportes.classList.add('d-none')
  mostrarListaExpedientes()
  elemento('#item-menu-perfil').classList.remove('active')
  elemento('#item-menu-tablero').classList.remove('active')
  elemento('#item-menu-catalogos').classList.remove('active')
  elemento('#item-menu-actores').classList.remove('active')
  elemento('#item-menu-expedientes').classList.add('active')
  elemento('#item-menu-reportes').classList.remove('active')
  sidebar.classList.remove('active')
  void cargarExpedientes()
})
elemento<HTMLButtonElement>('#ir-observaciones-institucionales').addEventListener('click', () => {
  limpiarFormularios()
  vistaPerfil.classList.add('d-none')
  vistaCatalogos.classList.add('d-none')
  vistaActores.classList.add('d-none')
  vistaTablero.classList.add('d-none')
  vistaExpedientes.classList.add('d-none')
  vistaReportes.classList.add('d-none')
  vistaObservacionesInstitucionales.classList.remove('d-none')
  for (const id of [
    'item-menu-perfil',
    'item-menu-tablero',
    'item-menu-catalogos',
    'item-menu-actores',
    'item-menu-expedientes',
    'item-menu-reportes',
  ])
    elemento(`#${id}`).classList.remove('active')
  elemento('#item-menu-observaciones-institucionales').classList.add('active')
  cerrarMenuMovil()
  void mostrarObservacionesInstitucionales(perfilActual?.roles ?? []).catch((error: unknown) =>
    notificar(mensajeError(error), 'error'),
  )
})
elemento<HTMLButtonElement>('#ir-reportes').addEventListener('click', () => {
  limpiarFormularios()
  vistaPerfil.classList.add('d-none')
  vistaCatalogos.classList.add('d-none')
  vistaActores.classList.add('d-none')
  vistaTablero.classList.add('d-none')
  vistaExpedientes.classList.add('d-none')
  vistaObservacionesInstitucionales.classList.add('d-none')
  vistaReportes.classList.remove('d-none')
  for (const id of [
    'item-menu-perfil',
    'item-menu-tablero',
    'item-menu-catalogos',
    'item-menu-actores',
    'item-menu-expedientes',
    'item-menu-observaciones-institucionales',
  ])
    elemento(`#${id}`).classList.remove('active')
  elemento('#item-menu-reportes').classList.add('active')
  cerrarMenuMovil()
  mostrarReportes(perfilActual?.roles ?? [])
})

function gestionarAceptacionLegal(error: unknown): void {
  if (!(error instanceof ErrorApi) || error.codigo !== 'ACEPTACION_LEGAL_REQUERIDA') {
    mostrarAlerta(alertaAcceso, mensajeError(error))
    return
  }
  void solicitarDecisionLegal(
    () => void consultarPerfil().then(cargarPerfil).catch(gestionarAceptacionLegal),
    () =>
      void cerrarSesion()
        .catch(() => undefined)
        .then(() => {
          mostrarAcceso()
          mostrarAlerta(
            alertaAcceso,
            'La decisión fue registrada. No puede continuar sin aceptar el documento vigente.',
            'warning',
          )
        }),
  ).catch((fallo: unknown) => mostrarAlerta(alertaAcceso, mensajeError(fallo)))
}

const formularioAcceso = elemento<HTMLFormElement>('#formulario-acceso')
formularioAcceso.addEventListener('submit', (evento) => {
  evento.preventDefault()
  formularioAcceso.classList.add('was-validated')
  if (!formularioAcceso.checkValidity()) return
  const boton = elemento<HTMLButtonElement>('#boton-acceso')
  boton.disabled = true
  void iniciarSesion(
    elemento<HTMLInputElement>('#correo-acceso').value,
    elemento<HTMLInputElement>('#contrasena-acceso').value,
  )
    .then(consultarPerfil)
    .then(cargarPerfil)
    .catch(gestionarAceptacionLegal)
    .finally(() => {
      boton.disabled = false
    })
})

elemento<HTMLFormElement>('#formulario-perfil').addEventListener('submit', (evento) => {
  evento.preventDefault()
  const formulario = evento.currentTarget as HTMLFormElement
  formulario.classList.add('was-validated')
  if (!formulario.checkValidity()) return
  const celular = elemento<HTMLInputElement>('#celular-perfil').value.trim()
  void actualizarPerfil({
    correo: elemento<HTMLInputElement>('#correo-perfil').value,
    ...(celular ? { celular } : {}),
    version: Number(elemento<HTMLInputElement>('#version-perfil').value),
  })
    .then((perfil) => {
      cargarPerfil(perfil, false)
      mostrarAlerta(alertaPerfil, 'Perfil actualizado correctamente.', 'success')
    })
    .catch((error: unknown) => mostrarAlerta(alertaPerfil, mensajeError(error)))
})

elemento<HTMLFormElement>('#formulario-contrasena').addEventListener('submit', (evento) => {
  evento.preventDefault()
  const formulario = evento.currentTarget as HTMLFormElement
  formulario.classList.add('was-validated')
  if (!formulario.checkValidity()) return
  void cambiarContrasena(
    elemento<HTMLInputElement>('#contrasena-actual').value,
    elemento<HTMLInputElement>('#contrasena-nueva').value,
  )
    .then(() => {
      formulario.reset()
      mostrarAcceso()
      mostrarAlerta(alertaAcceso, 'Contraseña actualizada. Ingrese nuevamente.', 'success')
    })
    .catch((error: unknown) => mostrarAlerta(alertaPerfil, mensajeError(error)))
})

function ejecutarCierreSesion(): void {
  void cerrarSesion()
    .catch(() => undefined)
    .then(mostrarAcceso)
}

elemento<HTMLButtonElement>('#boton-cerrar-sesion-navbar').addEventListener(
  'click',
  ejecutarCierreSesion,
)

elemento<HTMLFormElement>('#formulario-recuperacion').addEventListener('submit', (evento) => {
  evento.preventDefault()
  const resultado = elemento<HTMLElement>('#resultado-recuperacion')
  void solicitarRecuperacion(elemento<HTMLInputElement>('#correo-recuperacion').value)
    .then(() => {
      resultado.textContent = 'Si la cuenta cumple las condiciones, recibirá instrucciones.'
    })
    .catch((error: unknown) => {
      resultado.textContent = mensajeError(error)
    })
})

const tokenRestablecimiento = new URLSearchParams(window.location.hash.slice(1)).get('token')
if (tokenRestablecimiento) {
  vistaAcceso.classList.add('d-none')
  vistaRestablecimiento.classList.remove('d-none')
  sidebar.classList.remove('active')
  elemento<HTMLFormElement>('#formulario-restablecimiento').addEventListener('submit', (evento) => {
    evento.preventDefault()
    const formulario = evento.currentTarget as HTMLFormElement
    formulario.classList.add('was-validated')
    if (!formulario.checkValidity()) return
    void restablecerContrasena(
      tokenRestablecimiento,
      elemento<HTMLInputElement>('#contrasena-restablecida').value,
    )
      .then(() => {
        window.history.replaceState({}, '', window.location.pathname)
        mostrarAcceso()
        mostrarAlerta(alertaAcceso, 'Contraseña actualizada. Ya puede ingresar.', 'success')
      })
      .catch((error: unknown) =>
        mostrarAlerta(elemento<HTMLElement>('#alerta-restablecimiento'), mensajeError(error)),
      )
  })
} else if (tieneSesionCsrf()) {
  void consultarPerfil()
    .then(cargarPerfil)
    .catch((error: unknown) => {
      if (error instanceof ErrorApi && error.codigo === 'ACEPTACION_LEGAL_REQUERIDA') {
        gestionarAceptacionLegal(error)
      } else mostrarAcceso()
    })
} else mostrarAcceso()
